"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedDate = getFormattedDate;
var _constants = require("../constants");
var _padNumberStart = require("./padNumberStart");
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- we need to keep it like this as result is number */

const FILL_STRING = '0';

/**
 * Formats the date based on the {@link pattern date formatting pattern} and {@link calendarFormat calendar formatting settings}.
 * @param value Value to format
 * @param pattern Date formatting pattern
 * @param calendarFormat Culture settings for date formatting
 * @returns Formatted date
 */
function getFormattedDate(value, pattern, calendarFormat) {
  // eslint-disable-next-line complexity -- This function comes from kendo-core
  return pattern.replaceAll(_constants.dateFormatRegExp, match => {
    let result;

    // eslint-disable-next-line default-case -- no default case needed
    switch (match) {
      case 'd':
        result = value.getDate().toString();
        break;
      case 'dd':
        result = (0, _padNumberStart.padNumberStart)(value.getDate(), 2, FILL_STRING);
        break;
      case 'ddd':
        result = calendarFormat?.days?.abbreviatedNames[value.getDay()] ?? '';
        break;
      case 'dddd':
        result = calendarFormat?.days?.names[value.getDay()] ?? '';
        break;
      case 'M':
        result = (value.getMonth() + 1).toString();
        break;
      case 'MM':
        result = (0, _padNumberStart.padNumberStart)(value.getMonth() + 1, 2, FILL_STRING);
        break;
      case 'MMM':
        result = calendarFormat?.months?.abbreviatedNames[value.getMonth()] ?? '';
        break;
      case 'MMMM':
        result = calendarFormat?.months?.names[value.getMonth()] ?? '';
        break;
      case 'yy':
        result = (0, _padNumberStart.padNumberStart)(value.getFullYear() % 100, 2, FILL_STRING);
        break;
      case 'yyyy':
        result = (0, _padNumberStart.padNumberStart)(value.getFullYear(), 4, FILL_STRING);
        break;
      case 'h':
        result = (value.getHours() % 12 || 12).toString();
        break;
      case 'hh':
        result = (0, _padNumberStart.padNumberStart)(value.getHours() % 12 || 12, 2, FILL_STRING);
        break;
      case 'H':
        result = value.getHours().toString();
        break;
      case 'HH':
        result = (0, _padNumberStart.padNumberStart)(value.getHours(), 2, FILL_STRING);
        break;
      case 'm':
        result = value.getMinutes().toString();
        break;
      case 'mm':
        result = (0, _padNumberStart.padNumberStart)(value.getMinutes(), 2, FILL_STRING);
        break;
      case 's':
        result = value.getSeconds().toString();
        break;
      case 'ss':
        result = (0, _padNumberStart.padNumberStart)(value.getSeconds(), 2, FILL_STRING);
        break;
      case 'f':
        result = Math.floor(value.getMilliseconds() / 100).toString();
        break;
      case 'ff':
        {
          const resultNumber = value.getMilliseconds();
          if (resultNumber > 99) {
            result = Math.floor(resultNumber / 10).toString();
          }
          result = (0, _padNumberStart.padNumberStart)(resultNumber, 2, FILL_STRING);
          break;
        }
      case 'fff':
        result = (0, _padNumberStart.padNumberStart)(value.getMilliseconds(), 3, FILL_STRING);
        break;
      case 'tt':
        result = value.getHours() < 12 ? calendarFormat?.amDesignator ?? '' : calendarFormat?.pmDesignator ?? '';
        break;
      case 'z':
      case 'zz':
        {
          const resultNumber = value.getTimezoneOffset() / 60;
          const sign = resultNumber < 0;
          result = Math.abs(resultNumber).toString().split('.')[0];
          // result = (sign ? '+' : '-') + (match === 'zz' ? padString(result) : result);
          result = (sign ? '+' : '-') + (match === 'zz' ? result.padStart(2, FILL_STRING) : result);
          break;
        }
      case 'zzz':
        {
          let minutes = value.getTimezoneOffset();
          const sign = minutes < 0;
          result = Math.abs(minutes / 60).toString().split('.')[0];
          const resultNumber = Number.parseInt(result, 10);
          minutes = Math.abs(minutes) - resultNumber * 60;
          result = (sign ? '+' : '-') + result.padStart(2, FILL_STRING);
          result += `:${(0, _padNumberStart.padNumberStart)(minutes, 2, FILL_STRING)}`;
          break;
        }
    }
    return result ?? match.slice(1, -1);
  });
}
